"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5470],{

/***/ 65470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CollectionsType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72462);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84849);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71911);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30719);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55791);
/* harmony import */ var _plugins_swiperUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93801);
/* harmony import */ var _ViewPort__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33030);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_11__);





// import Swiper core and required modules

// Import Swiper React components






// Import Swiper styles


// install Swiper modules
swiper__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Autoplay */ .pt,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Lazy */ .oM
]);
function CollectionsType(props) {
    var dateLocale = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useLocale */ .bU)();
    var slidesPerView = props.hasOwnProperty("slidesPerView") ? props.slidesPerView : 3;
    var childRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var swiper_options = {
        mode: "dark",
        pagination: true
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        new _plugins_swiperUtils__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z(swiper_options).swiperOptions();
    });
    var builder = props.builder;
    var content = props.content;
    var articles = props.articles;
    var gallery_item_class = "panel-item no-padding hover-zoom bg-transparent h-100 w-100 ";
    var container_class = "container";
    if (props.type == "blog") {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].isValidString */ .Z.isValidString(builder.builder_news_view_width)) {
            container_class = builder.builder_news_view_width;
        }
        gallery_item_class += _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].isValidObjString */ .Z.isValidObjString(builder, "builder_news_radius") ? "border-radius-".concat(builder.builder_news_radius) : "";
    } else if (props.type == "category") {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].isValidString */ .Z.isValidString(content.category_view_width)) {
            container_class = content.category_view_width;
        }
        gallery_item_class += _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].isValidObjString */ .Z.isValidObjString(content, "tiles_radius") ? "border-radius-".concat(content.tiles_radius) : "";
    }
    var skeletonArticles = [];
    for(var i = 0; i < 6; i++){
        skeletonArticles.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            height: 460,
            width: 352,
            className: "b-rad-md"
        }, i.toString()));
    }
    var navigation = {
        enabled: true,
        nextEl: ".swiper-custom-next",
        prevEl: ".swiper-custom-prev"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(container_class, " py-5 collections-swiper"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "row w-100 m-0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "col-12 p-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
                    className: "p-b-60",
                    speed: 1000,
                    spaceBetween: slidesPerView > 3 ? 15 : 40,
                    navigation: true,
                    pagination: {
                        dynamicBullets: true,
                        clickable: true
                    },
                    autoplay: false,
                    // className="px-5 pb-5"
                    breakpoints: {
                        640: {
                            slidesPerView: 1
                        },
                        768: {
                            slidesPerView: 2
                        },
                        991: {
                            slidesPerView: slidesPerView
                        }
                    },
                    children: props.loadingArticles ? skeletonArticles : articles.map(function(article) {
                        var ref;
                        var created = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .formatMomentDate */ .XY)(dateLocale, new Date(article.created * 1000), "dddd Do MMMM");
                        var title = props.articlesContentType == "blog" ? created : article.title;
                        var subtitle = props.articlesContentType == "article" ? article.subtitle : props.articlesContentType == "blog" ? article.title : article.description;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ViewPort__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            skeletonItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                height: 460,
                                width: 352,
                                className: "b-rad-md"
                            }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                                className: props.setClass(article, ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_11___default()), {
                                    href: props.updateHref(article),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: gallery_item_class,
                                        onClick: function() {
                                            return props.clickHandler(article);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "inner bottom-left text-left padding-30",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        className: "btn-sm border-0 rounded-pill bg-design-color fs-11 m-b-10",
                                                        style: {
                                                            color: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].valueToBoolean */ .Z.valueToBoolean((ref = props.app) === null || ref === void 0 ? void 0 : ref.designMode) ? "#FFFFFF" : "#000000"
                                                        },
                                                        children: title
                                                    }),
                                                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].isValidString */ .Z.isValidString(subtitle) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                        className: "text-white text-left line-clamp-2 m-0 fw-normal",
                                                        children: subtitle
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "ar-1-1 bg-master-dark brightness-filter-80 " + (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].isValidString */ .Z.isValidString(props.itemClassName) ? props.itemClassName : ""),
                                                style: {
                                                    minHeight: 450,
                                                    height: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "psuedo-background ng-scope",
                                                    "data-pages-bg-image": true,
                                                    children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].isValidString */ .Z.isValidString(article.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        className: "psuedo-background-img",
                                                        layout: "fill",
                                                        sizes: "75vw",
                                                        quality: "75",
                                                        src: article.image,
                                                        alt: article.caption ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].removeEmojis */ .Z.removeEmojis(article.caption) : "Post Img",
                                                        placeholder: "blur",
                                                        blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                                    }) : _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].isValidArray */ .Z.isValidArray(article.images) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        className: "psuedo-background-img",
                                                        layout: "fill",
                                                        sizes: "75vw",
                                                        quality: "75",
                                                        src: article.images[0],
                                                        alt: article.caption ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].removeEmojis */ .Z.removeEmojis(article.caption) : "Post Img",
                                                        placeholder: "blur",
                                                        blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                })
                                            })
                                        ]
                                    })
                                })
                            }, article.id.toString())
                        }, article.id.toString());
                    })
                })
            })
        })
    });
}


/***/ })

}]);